import { DisciplineSearch } from "../models/ServiceRequest";
import { GetQueryString } from "../utils";
import API from "./api";

export const GetCareType = (configUrl: string) =>
  API.get(`${configUrl}api/master/CareTypes`);

export const GetDisciplines = (configUrl: string, payload: DisciplineSearch) =>
  API.get(`${configUrl}api/master/Disciplines?${GetQueryString(payload)}`);
